<template>
  <div>
    <div id="carouss" class="carousel slide carousel-fade h-100" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouss" data-slide-to="0" class="active"></li>
          <li data-target="#carouss" data-slide-to="1"></li>
        </ol>
        <div class="carousel-inner h-100">

          <div class="carousel-item active h-100">
            <div class="style_banniere py-5">
              <div class="container py-5"  v-if="bond.id">
                <div class="col-md-8 mx-auto">
                  <h5 class="gothic text-center">Appel pour bon</h5>
                  <h1 class="display-1 d-inline style_montant_bon text-center text-white gothicb">{{bond.amount.toFixed(2).replace('.', ',') |currency}}</h1>
                  <h5 class="gothic">Déja souscrit : <span class="text-dark gothicb">{{total}}%</span></h5>
                </div>
                <div class="text-center my-3">
                  <div class="mx-auto mb-3">
                    <div class="d-inline-block p-3 style_horloge_contour">
                      <h6 class="gothic style_text_jaune">Compte à rebout</h6>
                      <div class="d-flex justify-content-center">
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4">9</h1>
                          <small class="text-center">Jour</small>
                        </div>
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4 text-white-50">:</h1>
                        </div>
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4">13</h1>
                          <small class="text-center">Heurs</small>
                        </div>
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4 text-white-50">:</h1>
                        </div>
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4">15</h1>
                          <small class="text-center">Mins</small>
                        </div>
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4 text-white-50">:</h1>
                        </div>
                        <div class="mx-1">
                          <h1 class="gothic my-0 display-4">22</h1>
                          <small class="text-center">Secs</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button class="btn btn-dark"><span class="mx-3">Souscrire</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="bg-light py-5">
      <div class="container">
        <h2 class="gothicb title">Ross Money</h2>
        <div class="row">
          <div class="col-sm-8">
            <p>Procurez-vous du Ross Money auprès de nos marchands pour bénéficier des services de souscriptions de bonds et acheter chez nos accepteurs disponibles sur tout le territoire national.</p>
          </div>
          <div class="col-sm-4">
            <img src="../assets/img/rosspiece.png" class="img-fluid">
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="btn btn-lg p-3 zoomIn animated infinite btn-warning"><span class="mx-2">Acheter Ross</span></a>
        </div>
      </div>
    </div>

    <div class="style_img_bg py-5">
        <div class="container">
          <h2 class="gothicb text-white title">Nos taux</h2>
          <div class="my-5">
            <div class="row border-bottom my-3">
              <div class="col-sm-6"><h6 class="text-center text-white">Devise</h6></div>
              <div class="col-sm-6"><h6 class="text-center text-white">Parité</h6></div>
            </div>
            <div class="row border-bottom my-3" v-for="(value, name, index) in devi.change" v-if="name !== 'id'" :key="index">
              <div class="col-sm-6 text-center"><span class="text-white">1 {{name}}</span></div>
              <div class="col-sm-6 text-center"><span class="text-white">{{value *10000}} lR</span></div>
            </div>
          </div>
        </div>
    </div>

    <div class="py-5">
      <div class="container">
        <h2 class="gothicb title my-5">Commencez avec Ross</h2>
        <div class="row">
          <div class="card-group">
            <div class="card">
              <div class="mx-auto my-3">
                <img class="img-fluid" src="../assets/img/quiz.png" width="60" alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title text-center gothicb text-warning">Souscriptions</h5>
                <p class="card-text">Quand vous disposer du Ross, vous pouvez souscrire à un bond dans votre section ou à l'accueil. Ces souscriptions valables pour certaines périodes après laquel le système vous renvoie avec intêrets.</p><p>Plus de détails, veuillez nous contacter.</p>
              </div>
            </div>
            <div class="card">
              <div class="mx-auto my-3">
                <img class="img-fluid" src="../assets/img/portefeulle.png" width="60" alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title text-center gothicb text-warning">Votre portefeuille</h5>
                <p class="card-text">Vous bénéficiez d'un portefeuille Ross Money à l'inscription vous permettant d'opérer sur la plateforme et de bénéficier de tous les avantages afférant.</p>
              </div>
            </div>
            <div class="card">
              <div class="mx-auto my-3">
                <img class="img-fluid" src="../assets/img/rossdevise.png" width="60" alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title text-center gothicb text-warning">Marchands</h5>
                <p class="card-text">Approvisionnez-vous chez nos marchands suivant:
                  <ol>
                    <li>Landry G.(+229 97979797)</li>
                    <li>Jospin H.(+229 96969696)</li>
                    <li>Hippolyte A.(+229 95959595)</li>
                  </ol>
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'home',
  computed: {
    bond() { return this.$store.getters['resource/BOND'] },
    devi() { return this.$store.getters['resource/DEVI'] },
    total() { return 100*Math.round(this.bond.current/this.bond.amount) }
  },
  created() {
    this.$store.dispatch('resource/fetchBond');
    this.$store.dispatch('resource/fetchDevi');
  },
}
</script>

<style scoped lang="scss">
</style>